export default "__VITE_ASSET__CCvALNbi__"